import axios from 'axios'
import authHeader from './AuthHeader'
import { API_URL } from '../config/api'

class ConfigService {

  getConfigNoAuth = async () => {
    return await axios.get(API_URL + '/configNoAuth')
  }

  getConfig = async () => {
    return await axios.get(API_URL + '/config', { headers: authHeader() })
  }

  updateConfig = async (configParams) => {
    return await axios.patch(API_URL + '/config', configParams, { headers: authHeader() })
  }

}

export default new ConfigService()